module.exports = __webpack_public_path__ + "img/surplus_icon.e004e0f2.png";